import Onboarding from '@iez/features/onboarding/'
import HappyWomenDay from '@iez/illustrations/HappyWomenDay'
import TheWorldIsMine from '@iez/illustrations/TheWorldIsMine'
import Dreamer from '@iez/illustrations/Dreamer'
import News from '@iez/illustrations/News'
import Yako from './yako/'

export default () => {
  Onboarding({
    screens: [{
      title: `L'annuaire 2.0 des acteurs positifs`,
      text: `Venez lancer, partager, découvrir et soutenir des initiatives écologiques et solidaires.`,
      image: Yako
    }, {
      text: `L'application comporte 3 types d'utilisateurs: choisissez lequel vous serez.`,
      image: HappyWomenDay
    }, {
      title: 'Assos',
      text: `Pour vous, associations et auteurs de projets solidaires et engagés, partagez et sensibilisez à votre cause.`,
      image: TheWorldIsMine
    }, {
      title: 'Giver',
      text: `C’est la plateforme idéale pour diffuser vos annonces tout en soutenant des associations et en étant acteur du visionnage volontaire.`,
      image: News
    }, {
      title: 'Viewer',
      text: `Retrouvez-vous dans une communauté engagée pour découvrir et soutenir des causes justes.`,
      image: Dreamer
    }],
    goTo: `Authentication-PhoneNumber`
  })
}
